/**
 * 公共 - 中文
 * 应用通用、登录、通用消息等
 */
export default {
  // 应用通用
  app: {
    title: '智能硬件经销商管理系统',
    emergencyContactSettingsTitle: '紧急联系人设置',
    followUpStudentTitle: '跟进学员',
    followUpStudentTabAddFollow: '添加跟进',
    followUpStudentTabCompleteProfile: '完善资料',
    followUpStudentStudentName: '学员姓名',
    followUpStudentCustomerIntent: '客户意向度',
    followUpStudentFollowStatus: '跟进状态',
    followUpStudentStudentTags: '学员标签',
    followUpStudentCallCommStatus: '话务沟通状态',
    followUpStudentFollowContent: '跟进内容',
    followUpStudentFollowContentTipLine1:
      '如：今天是第几次跟进；讲解了松鼠Ai的优势等；学员的意向科目是什么；',
    followUpStudentFollowContentTipLine2:
      '家长态度如何;是否预约下次跟进等...',
    followUpStudentUploadImageHint:
      '支持jpg/png格式，最佳尺寸1080x1920，大小不超过5MB',
    followUpStudentCredentialSample: '凭证实例',
    followUpStudentNextCommTime: '下次沟通时间',
    followUpStudentSelectDate: '选择日期',
    followUpStudentSelectTime: '选择时间',
    followUpStudentPlaceholderSelectIntent: '请选择客户意向度',
    followUpStudentPlaceholderSelectFollowStatus: '请选择跟进状态',
    followUpStudentPlaceholderFollowContent: '请输入跟进内容',
    followUpStudentPhone: '手机号',
    followUpStudentPlaceholderPhone: '请输入手机号',
    followUpStudentSex: '性别',
    followUpStudentMale: '男',
    followUpStudentFemale: '女',
    followUpStudentBirthday: '出生日期',
    followUpStudentPlaceholderBirthday: '选择出生日期',
    followUpStudentHomeAddress: '家庭住址',
    followUpStudentPlaceholderHomeAddress: '请输入家庭地址',
    followUpStudentStudentType: '学员类型',
    followUpStudentPlaceholderSelectStudentType: '请选择学员类型',
    followUpStudentStageGrade: '阶段年级',
    followUpStudentPlaceholderSelectStage: '请选择阶段',
    followUpStudentPlaceholderSelectGrade: '请选择年级',
    followUpStudentSource: '来源',
    followUpStudentStudentSchool: '学员学校',
    followUpStudentPlaceholderSelectSchool: '请选择学员学校',
    followUpStudentCourseAdvisor: '课程顾问',
    followUpStudentPlaceholderSelectAdvisor: '请选择课程顾问',
    followUpStudentRegionOne: '区域一',
    followUpStudentRegionTwo: '区域二',
    followUpStudentContact1: '联系人1',
    followUpStudentPlaceholderContact1: '请输入联系人1',
    followUpStudentContact2: '联系人2',
    followUpStudentPlaceholderContact2: '请输入联系人2',
    followUpStudentContact3: '联系人3',
    followUpStudentPlaceholderContact3: '请输入联系人3',
    followUpStudentRemark: '备注',
    followUpStudentPlaceholderRemark500: '500字以内',
    selectProductTitle: '选择商品',
    uploadImageTitle: '上传图片',
    confirmDeleteComponent: '您确定要删除该组件吗?',
    logisticsDetailsTitle: '物流详情',
    cannotSubscribeTipTitle: '不可订阅提示',
    paymentTitle: '支付',
    shipmentTitle: '发货',
    assignCoursesTitle: '分配课程',
    batchCancelAssignedCoursesTitle: '批量取消分配课程',
    editSchoolTitle: '编辑学校',
    addSchoolTitle: '新增学校',
    editInfoTitle: '编辑资料',
    addInfoTitle: '新增资料',
    addInformationTitle: '新增资料',
    addRelatedOrderTitle: '新增关联订单',
    verificationPromptTitle: '验证提示',
    addInvoiceTitle: '新增发票',
    addContractTitle: '新增合同',
    multipleSchoolQueryTitle: '多校查询',
    changeDetailsTitle: '变更详情',
    subjectChangeWarningTitle: '主体变更预警',
    editAccountTitle: '编辑账号',
    addAccountTitle: '新增账号',
    agentInitialAccountAmountTitle: '代理商初始账户金额',
    cashRechargeTitle: '现金账户充值',
    switch: '切换',
    enable: '启用',
    disable: '禁用',
    confirm: '确定',
    cancel: '取消',
    save: '保存',
    delete: '删除',
    edit: '修改',
    add: '新增',
    search: '搜索',
    reset: '重置',
    refreshStatus: '刷新状态',
    export: '导出',
    exportDetail: '导出明细',
    import: '导入',
    upload: '上传',
    download: '下载',
    done: '完成',
    next: '下一步',
    nextStep: '下一步',
    prevStep: '上一步',
    downloadImportTemplate: '下载导入模版',
    operation: '操作',
    detail: '详情',
    details: '详情',
    userDetail: '用户详情',
    submit: '提交',
    back: '返回',
    labelColon: '：',
    loading: '加载中...',
    pleaseEnter: '请输入',
    yuan: '元',
    complete: '完成',
    success: '操作成功',
    saveSuccess: '保存成功',
    uploadSuccess: '上传成功',
    uploadFail: '上传失败',
    uploadFileSize5MB: '上传文件大小不能超过 5MB!',
    failed: '操作失败',
    saveFail: '保存失败',
    modifyFail: '修改失败',
    loadFail: '加载失败',
    claimFail: '领取失败',
    inviteFail: '邀约失败',
    changeFail: '更改失败',
    experienceFail: '体验失败',
    linkSuccess: '关联成功',
    linkFail: '关联失败',
    confirmSuccess: '确认成功',
    editFail: '编辑失败',
    orderQueryFail: '订单查询失败',
    submitFail: '提交失败',
    createSuccess: '创建成功',
    createFail: '创建失败',
    addMaterialSuccess: '新增资料成功',
    modifyMaterialFail: '修改资料失败',
    addMaterialFail: '新增资料失败',
    deleteMaterialFail: '删除资料失败',
    noData: '暂无数据',
    helpCenter: '帮助中心',
    closeSystem: '关闭系统',
    accountSecurity: '账号安全中心',
    exportDownload: '导出下载',
    codeSuccess: '验证码发送成功',
    codeSendFailed: '验证码发送失败',
    days: '天',
    startDate: '开始日期',
    endDate: '结束日期',
    to: '至',
    filterPlaceholder: '请输入搜索内容',
    available: '待选',
    selected: '已选',
    thisWeek: '本周',
    thisMonth: '本月',
    lastWeek: '上周',
    lastMonth: '上月',
    phoneVerify: '手机验证',
    replaceVerifyPhone: '更换验证手机',
    retrievePassword: '找回密码',
    retrievePasswordTip: '使用账号绑定的手机号找回密码',
    codePlaceholder: '验证码',
    getCodeAgain: '重新获取验证码',
    send: '发送',
    countDownResend: '{n}s后重新获取',
    loginDeprecNotice: '此登录入口将于2024年10月31日正式关停，若您的账号仍未升级，请在登录后根据系统指引绑定手机号完成升级，如有疑问您可咨询松鼠智能客服。',
    close: '关闭',
    newPassword: '新密码',
    pleaseEnterNewPassword: '请输入新密码',
    selectAll: '全选',
    serialNo: '序号',
    tip: '提示',
    pleaseSelect: '请选择',
    selectAgentPlaceholder: '请选择代理商ID/代理商名称',
    searchAgentPlaceholder: '输入代理商ID/代理商名查找',
    select: '选择',
    name: '姓名',
    label: '付款方式：',
    amount: '充值金额：',
    total: '总计',
    all: '全部',
    yes: '是',
    no: '否',
    public: '公共',
    private: '私有',
    attention: '注意',
    goToExportDownload: '请前往',
    importExport: '导入导出',
    goToExportDownloadSuffix: '进行下载',
    notNow: '暂不前往',
    goToDownload: '前往导出下载',
    changeVerifyPhoneTitle: '更换验证手机号-身份验证',
    changePhoneBindTitle: '更换手机号-绑定新手机号',
    copySuccess: '复制成功',
    more: '更多',
    view: '查看',
    copy: '复制',
    normal: '正常',
    disabled: '禁用',
    primaryTag: '主',
    planningDept: '统筹部',
    classHours: '课时',
    classHoursWithNum: '{n}课时',
    unbound: '未绑定',
    bindPhoneTip: '绑定手机号后，可使用该手机号登录系统及找回密码',
    pinTop: '置顶',
    viewDetail: '查看详情',
    noPermissionContactAdmin: '暂无权限，请联系管理员！',
    noPermissionContactAgentAdmin: '您暂无权限，请联系代理商管理员',
    noPermissionRestrictedPrefix: '您的系统使用已被限制。限制原因：',
    noPermissionContactCustomerService: '请联系客服',
    queryBalanceFailed: '查询余额失败',
    accountCreateTip: '账号创建后，账号的状态是"待确认"，"待确认"的账号无法登录。创建的同时员工会收到总部钉钉加入的邀请，下载并打开钉钉，接受邀请加入总部后，账号就会从"待确认"变为"正常"状态，即可登录系统。',
    continue: '继续',
    accountUpgrade: '账号升级',
    accountUpgraded: '账号已经升级',
    accountUpgradeIntro: '仅需一分钟，将您的代理商账户升级为',
    squirrelAiAccount: '松鼠Ai账号',
    upgradeBenefits: '升级后获得以下权益：',
    unifiedAccount: '统一账号',
    unifiedAccountDesc: '通过一个手机号码，管理全部的代理商账号、分析员账号',
    security: '安全保密',
    securityDesc: '绑定手机和钉钉提高账号安全性',
    joinTraining: '参与培训',
    joinTrainingDesc: '加入松鼠云上钉钉组织，获得优质培训资料，了解最新功能',
    upgradeNow: '立即升级',
    bindPhone: '绑定手机号',
    bindPhoneDesc: '我们将根据手机号，创建或绑定松鼠Ai账号',
    phoneForRecovery: '请输入账号手机号，可用于找回密码',
    scanToActivate: '扫描完成账号激活',
    goToDingTalk: '前往钉钉完成升级',
    mergeAccount: '合并账号',
    mergeAccountDesc: '如果你有其他代理商账号需要合并到松鼠Ai账号，请依次添加',
    accountList: '账号列表',
    addAccount: '+添加账号',
    refresh: '刷新',
    contactService: '如遇问题请联系松鼠Ai智能客服',
    setFilterFirst: '请先设置筛选条件',
    bindMobile: '绑定手机',
    modifyPassword: '修改密码',
    exportDownloadLabel: '导出下载',
    // Common menu labels used as `$t('common.xxx')` (aliased to `app.xxx` in `src/i18n/index.js`)
    purchasingCenter: '采购中心',
    salesCenter: '销售中心',
    serviceCenter: '服务中心',
    financeCenter: '财务中心',
    businessManagement: '业务管理',
    innovationBusiness: '创新业务',
    deliveryManagement: '发货管理',
    agentServiceProvider: '代理服务商',
    headquartersTools: '总部工具',
    configBackend: '后台配置',
    statisticalAnalysis: '统计分析',
    warehouseManagement: '仓库管理',
    agentManagement: '代理商管理',
    resourceLibrary: '资源库',
    referralHelpCenter: '转介绍帮助中心',
    referralPerformanceQuery: '关于转介绍业绩查询及使用规则，请参阅帮助中心；',
    referralCustomerInRegionQuery: '关于区域内转介绍客户的查询，请参阅帮助中心；',
    referralCustomerFirstContract: '关于转介绍客户首笔合同款奖励的计算规则和查询，请参阅帮助中心；',
    referralCustomerFirstContract2: '关于转介绍客户首笔合同款奖励的计算规则和查询，请参阅帮助中心；',
    referralCustomerInRegion: '转介绍客户所在区域',
    channelRebateService: '关于渠道代的返佣和服务费奖励的计算规则和查询，请参阅帮助中心；',
    channelRebateService2: '关于渠道代的返佣和服务费奖励的计算规则和查询，请参阅帮助中心；',
    storageFeeExemptionNotice: '仓储费豁免公告',
    // Callout/call-line helper labels
    callLineBusy: '呼叫线路繁忙',
    outboundLineBusy: '外呼线路繁忙',
    notMigrated: '未迁移',
    hardPhone: '硬话机',
    timeDifferenceIs: '时间差为',
    downloadCertTemplate: '下载证书模版',
    dealerMiniProgram: '经销商小程序',
    headquartersNotice: '总部通知',
    // Work order / entry account helper labels
    agent: '代理商',
    dealer: '经销商',
    analyst: '分析员',
    analystAccount: '分析员账号',
    mainAccount: '主账号',
    subAccount: '子账号',
    mobile: '手机号',
    myWorkOrder: '我的工单',
    myCustomerService: '我的客服',
    noCustomerFound: '暂无客户',
    noDeviceFound: '暂无设备',
    openEntryAccount: '入门账号开通',
    learningMachine: '学习机',
    // Slider helper comparisons
    creditOrders: '赊货订单',
    rechargeFlow: '充值流程',
    bigStudyRoom: '大自习室',
    // Freight / Duxue dialog helper texts
    texteu15: '取消',
    texttnry: '运费方案',
    '10': '提示',
    accountSecurityCenter: '账号安全中心',
    targetReminder: '目标设定提醒',
    remindLater: '稍后再说',
    goToSet: '前往设定',
    newNotice: '您有一条新的公告消息',
    viewLater: '一会查看',
    viewNow: '立即查看',
    important: '重要',
    emergency: '紧急',
    callinTip: '线索正在呼入，请及时处理！',
    leadName: '线索名字',
    leadPhone: '线索手机号',
    followStatus: '跟进状态',
    calloutNotOpen: '外呼功能未开通',
    calloutNotOpenTip: '亲爱的经销商您好，您当前使用的外呼服务处于未开通状态，您可点击"前往开通"按钮进行开通或续期操作',
    thinkAgain: '再想想',
    goToOpen: '前往开通',
    goToRecharge: '前往充值',
    calloutOverdue: '外呼功能已欠费',
    calloutOverdueTip: '亲爱的经销商您好，您当前使用的外呼服务已超出使用话费的额度，您可点击"前往充值"按钮进行话费充值操作',
    calloutBusy: '外呼功能线路繁忙',
    iKnow: '我知道了',
    gotIt: '我知道了',
    calloutBusyTip: '当前为外呼线路繁忙，预计XX分钟后将有空余线路',
    callTips: '温馨提示',
    callTipsContent: '为保证通话质量，建议您使用带麦克风的耳机插入电脑后进行外呼',
    noMoreRemind: '我知道了，无需再提醒',
    continueCallout: '继续外呼',
    // 全局壳层组件文案（与 master 硬编码一致；$t('common.xxx')）
    ddModalJoinHqTitle: '加入松鼠云上总部',
    ddModalJoinHqSubtitle: '获取代理商运营秘笈，光速学会运营知识',
    ddModalBulletIndustry: '了解行业背景',
    ddModalBulletSystem: '学会代理商系统操作方法',
    ddModalBulletSales: '提升自己销售、服务能力',
    ddModalScanToJoin: '钉钉扫码加入',
    ddModalTrainUnlockTitle: '完成钉钉培训后解锁',
    ddModalMobileLearn: '手机钉钉扫码进行学习',
    ddModalDesktopLearn: '电脑钉钉直接学习',
    ddModalSignupFailed: '报名失败，请稍后再试',
    trainingBannerCountdownPrefix: '培训倒计时 ',
    trainingBannerUrgentSuffix: ' 天，逾期未完成，目录将会被锁定',
    trainingBannerGoTrain: '前往培训',
    headerPersonalCenter: '个人中心',
    editorPlacementAreaLabel: '组件放置区域',
    notFoundTitle: '页面不存在',
    notFoundTip: '您访问的页面不存在或已被移除',
    notFoundBackHome: '返回首页',
    passwordResetSuccess: '密码修改成功, 请使用新密码登录',
    passwordResetFail: '密码修改失败',
    verifySuccess: '验证成功！',
    verifyFail: '验证失败！',
    editAccountSuccess: '编辑账号成功！',
    editAccountFail: '编辑账号失败！',
    creditOrderPayTip: '赊货订单付款要求',
    creditOrderPayDesc: '经销商销售设备激活回款后，需要支付赊货订单的尾款，',
    exemptTip: '从收到提货券之日起',
    exemptTip2: '天内，定义为提货券的豁免期；豁免期内的提货券是免收仓储管理费的。具体规则详见：',
    exemptTip3: '根据以上规则，截止昨天你有',
    exemptTip4: '元的提货券即将过豁免期，请尽快下单支付提货券，系统将对过豁免期未下单的提货券，收取相应的仓储管理费；',
    doubleOrderTip: '双重订单是省代关联本省代理商、经销商的账户现金，实现集中备货的采购订单。具体规则详见：',
    agentAccountTip: '代理商账户常见问题',
    subscriptionTip: '订阅档位定义及查询',
    referralChannel: '转介绍及渠道代',
    guinnessTitle: '吉尼斯证书申请须知：',
    guinnessP1: '电子证书申请截⽌⽇期为',
    guinnessP2: '，请在截⽌前申请；现纸质证书已停止申请；',
    guinnessP3: '学员姓名和英⽂姓名将⽤在证书中，请认真确认与填写；',
    guinnessP4: '若想',
    guinnessP5: '修改学⽣姓名',
    guinnessP6: '，请至"家长通小程序-学习报告"中修改，如有问题请咨询客服；英文姓名请在本页填写和修改；',
    guinnessP7: '吉尼斯电⼦证书免费申请；吉尼斯纸质证书单价为¥300；松鼠不收取任何中间费用；',
    guinnessP8: '电⼦证书申请后可直接下载；纸质证书由于制作时间过⻓，请耐⼼等待。',
    studentNameCertNotice: '学员姓名和英文姓名将用在证书中，请认真确认与填写；',
    ifWantTo: '若想',
    modifyStudentName: '修改学生姓名',
    pleaseGoToParentApp: '，请至"家长通小程序-学习报告"中修改，如有问题请咨询客服；英文姓名请在本页填写和修改；',
    guinnessDigitalCertFree: '吉尼斯电子证书免费申请；吉尼斯纸质证书单价为¥300；松鼠不收取任何中间费用；',
    guinnessCertDownloadWait: '电子证书申请后可直接下载；纸质证书由于制作时间过长，请耐心等待。',
    startCallout: '开始外呼',
    endCallout: '结束外呼',
    calloutOnlineSuccess: '外呼服务上线成功',
    calloutOfflineSuccess: '外呼服务下线成功',
    micPermissionFail: '麦克风权限请求失败，请检查您的浏览器设置',
    getCustomerFail: '获取客户信息失败！',
    pleaseStartCallout: '请点击右上角"开始外呼"后进行外呼～',
    serviceError: '服务异常！',
    exportTaskSubmitted: '导出任务提交成功',
    pleaseProvideApiUrl: '请传入接口路径',
    exportFailed: '导出失败',
    systemError: '系统异常，请联系管理员',
    confirmRemoveFile: '确定移除 {name}？',
    uploadImage: '上传图片',
    cancelUpload: '取消上传',
    clickUpload: '点击上传',
    within100Chars: '100字以内',
    cancelUploadConfirm: '点击取消后您填写的信息将丢失，您确定取消？',
    uploadImageFail: '上传图片失败，请删除后重新上传',
    pleaseUploadImage: '请上传图片！',
    pleaseReupload: '请重新上传',
    selectCommodity: '选择商品',
    pleaseSelectJumpType: '请选择跳转类型',
    pleaseSelectImageLink: '请选择图片跳转链接',
    pleaseEnterLink: '请输入链接，输入前确保可以访问',
    searching: '正在搜索中',
    book: '书籍',
    other: '其他',
    pleaseSelectUser: '请选择用户',
    pleaseEnterKeywordFilter: '请输入关键字过滤',
    pleaseSelectProductType: '请选择商品类型',
    pleaseSelectCounter: '请选择柜台',
    pleaseSelectProvinceCity: '请选择省市区',
    pleaseSelectProvinceCityDistrict: '请选择省份/市',
    pleaseSelectFault: '请选择故障分类',
    pleaseSelectAgentRegion: '请选择代理商所属区域',
    startDatePlaceholder: '开始日期',
    endDatePlaceholder: '结束日期',
    clearFilter: '清除筛选',
    collapse: '收起',
    expand: '展开',
    query: '查询',
    clear: '清空',
    pleaseFillRequired: '请填写必填字段！',
    requiredField: '此项必填',
    invoiceQtyDecimalQ: 'Q：为什么开票数量有是小数？',
    invoiceQtyDecimalA: 'A：货款类的提现金额是下级经销商的订货款转入代理商提现账户的钱，松鼠已经向经销商的订单开过销售发票了，因此这个货款再被提现出来，要根据原始的订单对应商品型号、单价、金额红冲发票或反向开销售发票给松鼠，根据本次申请提现的金额用到不同订单的货款，会生成对应不同金额的开票信息，金额、单价固定的情况下，数量就是小数了',
    socketConnectFailRetry: '无法连接到消息系统，请检查网络状态后重试！',
    socketConnectFailClose: '无法连接到消息系统，请关闭系统重试！',
    transferSuccess: '转交成功',
    transferFail: '转交失败',
    noPermissionAskSuperior: '暂无权限，请上级为您开通对应权限',
    pleaseSelectAdPosition: '请选择广告位置',
    pleaseEnterAdName: '请输入广告名称',
    pleaseEnterSort: '请输入排序',
    pleaseSelectStatus: '请选择状态',
    pleaseSelectDisplayScope: '请选择显示范围',
    publishSuccess: '发布成功',
    codeSentViewOnPhone: '验证码发送成功，请在手机上查看！',
    pleaseEnterContactName: '请输入联系人姓名',
    pleaseEnterCorrectPhoneNum: '请输入正确的手机号码',
    passwordSafetyTip: '为保证账户安全，请及时更新密码',
    oldPassword: '原密码',
    newPassword: '新密码',
    confirmNewPassword: '确认新密码',
    pleaseEnterOldPassword: '请输入原密码',
    pleaseEnterNewPassword: '请输入新密码',
    pleaseConfirmNewPassword: '请确认新密码',
    pleaseEnterNewPasswordAgain: '请再次输入新密码',
    passwordMismatch: '两次新密码输入不一致',
    pleaseReenterNewPassword: '请重新输入新密码',
    cancel: '取消',
    confirm: '确认',
    newNotice: '您有一条新的公告消息',
    viewNoticeDetail: '查看公告详情',
    tip: '提示',
    confirmDelete: '确认删除吗？',
    confirmClose: '确认关闭？',
    confirmReturnFreight: '确定要退还运费吗？',
    returnFreightSuccess: '退还成功',
    returnFreightFail: '退还失败',
    returnGoodsTip: '发货订单退货后，设备sn码将退回，发货信息将删除，请谨慎操作！',
    returnGoodsSuccess: '退货成功',
    pleaseEnterPhoneForCode: '请输入手机号',
    codeSentSuccess: '验证码发送成功',
    codeSentFail: '验证码发送失败',
    passwordResetSuccess: '密码重置成功, 请使用新密码登录',
    passwordResetFail: '密码重置失败',
    login: '登录',
    passwordLogin: '密码登录',
    phoneLogin: '验证码登录',
    usernamePlaceholder: '请输入用户名/手机号',
    passwordPlaceholder: '请输入密码',
    phone: '手机号',
    password: '密码',
    verifyCode: '验证码',
    getCode: '获取验证码',
    rememberMe: '记住我',
    forgotPassword: '忘记密码',
    loginSuccess: '登录成功',
    loginFailed: '登录失败',
    verifySuccess: '验证成功',
    pleaseEnterPhone: '请输入手机号',
    pleaseEnterPassword: '请输入密码',
    pleaseEnterVerifyCode: '请输入验证码',
    pleaseEnterOriginalPhone: '请输入原手机号',
    pleaseEnterNewPhone: '请输入新手机号',
    invalidPhone: '请输入有效的手机号',
    bindSuccess: '绑定成功',
    upgradeSuccess: '您的账号已经升级为松鼠Ai账号，请从统一登录平台登录',
    permissionError: '啊欧，您的访问权限异常，请联系客服进行处理',
    requestFailed: '请求失败',
    verifyFailed: '验证失败',
    codeSentTip: '验证码发送成功，请在手机上查看！',
    popupWillCloseIn: '弹窗将在',
    secondsAutoClose: '秒后自动关闭',
    auto_1_33bb0b88: '大模型数据分析服务系',
    unsupervisedStudentDataTip: '不督学学员的学情数据，可前往大模型数据分析服务系统查看',
    auto_1_4419517d: '上海市普陀区金沙江路',
    auto_11_3c1407e3: '本次支付将扣除',
    auto_12_21efd9b0: '请确认是否取消订单一旦取消已支付款项会退回',
    auto_14_7788d61a: 'nbsp话费单价',
    auto_15_6c5f790c: '开通使用协议',
    auto_17_8032e637: '付款',
    auto_18_68eb91fb: '原价',
    auto_19_6aed0f56: '不限人数含',
    auto_20_a2a536d4: '到期自动续费',
    auto_21_febbef1e: '为避免眈误您的外呼业务开展根据您选择的开通月数到期后默认',
    auto_26_f93ba179: '灵活使用',
    auto_28_1d2a816b: '开通使用协议',
    auto_30_fc80b0ff: '付款',
    auto_31_5b3591c1: '不限人数含',
    auto_32_34c314f2: '到期自动续费',
    auto_35_056836b2: '灵活使用支持退费',
    auto_36_2c8b792e: '开通使用协议',
    auto_38_657cc6d0: '付款',
    auto_39_29fb07b1: '选定布局区域在下方添加图片',
    auto_41_3411d78e: '宽度',
    auto_42_0daf419f: '宽度',
    auto_43_353730c1: '宽度',
    auto_44_2ffcd381: '',
    auto_46_c3fb5864: '',
    auto_48_0aa3291b: '',
    auto_50_d009fe60: '',
    auto_52_bfa198af: '',
    auto_52_cd58f41b: '请先输入开通月数',
    auto_53_9153b4fc: '请先阅读并勾选外呼服',
    auto_54_014575b8: '',
    auto_54_21ddab8a: '请先输入有效的话费金',
    auto_55_4577be6a: '请先阅读并勾选外呼服',
    auto_56_9329c308: '',
    auto_56_cea773ed: '支付成功',
    auto_58_aaa2e80b: '购买成功',
    auto_59_a1e1594b: '付款失败',
    auto_60_6c08e91d: '下一步',
    auto_60_d977a26d: '请添加图片',
    auto_61_84f03fb0: '点击更换图',
    auto_62_b7fb536e: '我的工单',
    auto_62_efa11156: '验证成功',
    auto_63_9c495a0c: '将会提交工单给技术专家进行处理',
    auto_63_c72e441b: '更换手机号绑定新手机',
    auto_65_5b3129b0: '验证码错误',
    auto_66_3d5ad168: '手机验证',
    auto_66_4c74e75e: '已完结工单',
    auto_67_2240de22: '取消',
    auto_67_99c2c990: '已完结工单是技术专家已经回复了问题结果您可以点击工单查看工单',
    auto_68_3c08da52: '确认',
    auto_68_419e05d6: '新进度',
    auto_69_31ad8c59: '您的工单都在处理中请耐心等待技术专家的回复哦',
    auto_69_b96f9f4f: '登录失败',
    auto_70_1ee3a0b3: '处理中工单',
    auto_70_9ca27d68: '证明文件',
    auto_71_44fb8798: '关闭',
    auto_71_6d2b1005: '处理中工单是客服已经帮您提交工单请耐心等待技术专家回复',
    auto_72_794828ac: '您的工单都已完结请去已完结工单中查看技术专家回复哦',
    auto_73_0771c815: '提交审核',
    auto_73_32adfc8d: '工单详情',
    auto_74_f6fd4c00: '工单信息',
    auto_75_38ddfcc9: '请输入学员账号',
    auto_75_95cc1a8c: '工单ID',
    auto_76_40dca735: '工单标题',
    auto_76_e734dd37: '情况说明长度为字',
    auto_77_39620e02: '工单创建人',
    auto_78_0d0b0047: '工单创建时间',
    auto_78_2d6f0fc5: '请上传证明文件',
    auto_79_94495c94: '请选择审核结果',
    auto_79_bd9cd84d: '工单状态',
    auto_80_0cf9382a: '工单处理人',
    auto_80_661f2449: '请输入审核意见',
    auto_81_36b9a3ac: '审核跨主体督学申请',
    auto_81_3ac0816a: '工单完结时间',
    auto_82_403c2cbf: '问题处理结果',
    auto_83_2933c8fe: '技术专家在加急处理您的问题中请您耐心等待',
    auto_84_44eecdea: '跨主体督学申请',
    auto_84_c2300510: '选定布局区域在下方添加图片',
    auto_85_7d350f62: '学员账号验证失败',
    auto_86_492ffaa8: '验证学员账号失败请稍',
    auto_86_5646605a: '宽度',
    auto_87_0b2e5eb6: '宽度',
    auto_87_4591b39a: '只能上传图片格式的文',
    auto_88_6d73238a: '上传文件大小不能超过',
    auto_88_9b344fb4: '宽度',
    auto_89_7953c2d5: '文件上传成功',
    auto_89_876f6ed4: '',
    auto_90_33e94845: '文件上传失败',
    auto_91_2869b272: '审核拒绝',
    auto_91_2e80c943: '',
    auto_93_311be945: '',
    auto_94_15733a82: '申请前校验失败',
    auto_95_294563f7: '申请已审核无需重复提',
    auto_95_d8daef36: '',
    auto_97_473f6ccf: '',
    auto_99_2d1fdf0f: '',
    auto_99_d0373366: '当前状态无需提交申请',
    auto_100_b3dad3de: '审核提交成功',
    auto_101_1a13328b: '',
    auto_102_d12681fa: '提交失败',
    auto_103_3a39ddcd: '提交失败请稍后重试',
    auto_104_4c4e4b6f: '辅助空白',
    auto_105_9be7183a: '请添加图片',
    auto_106_6d719469: '无边距',
    auto_106_ec081e14: '点击更换图',
    auto_107_f5a8f75f: '本期名额',
    auto_108_8e48f7fd: '实线',
    auto_108_e84a4be3: '限制',
    auto_109_cfe7889d: '虚线',
    auto_110_20b0a497: '支持jpgpnggif格式RGB模式不超过',
    auto_110_b7b7726f: '点线',
    auto_111_80630d3f: '显示',
    auto_112_cb755ac2: '支持jpgpnggif格式RGB模式不超过',
    auto_113_1c37f508: '显示',
    auto_114_34e7eb5a: '支持jpgpnggif格式RGB模式不超过',
    auto_115_b9db9487: '正常模式',
    auto_116_10610081: '支持jpgpnggif格式RGB模式不超过',
    auto_117_7d189d5c: '正常模式',
    auto_118_b48a6ff1: '联系电话',
    auto_119_0f491a54: '联系地址',
    auto_119_c860d08a: '方形',
    auto_120_483ae5a2: '点击上传二维码',
    auto_121_95bbd0e8: '扫码关注公众号',
    auto_121_fe8681f1: '方形',
    auto_123_1131d0ec: '鼠标拖拽调整商品顺序',
    auto_123_7bc0c4f1: '居左',
    auto_125_206113c3: '点击添加商品',
    auto_125_59231844: '居左',
    auto_126_ef406980: '添加商品分组',
    auto_127_3a945992: '鼠标拖拽调整分组顺序',
    auto_127_3af34192: '显示',
    auto_128_be01345d: '点击添加商品',
    auto_129_0cc92e04: '显示',
    auto_129_abc25f15: '更换图片',
    auto_130_fdb36e36: '清空图片',
    auto_131_32b40046: '图片广告',
    auto_131_99b24db8: '显示',
    auto_132_858e59ff: '拖动选中的导航可对其排序',
    auto_133_05ace53e: '默认颜色',
    auto_134_7c4e567c: '默认颜色',
    auto_134_f4585f3e: '点击添加图片',
    auto_135_c0e8816b: '更换',
    auto_135_ebe23c00: '样式三',
    auto_137_36c54da9: '内部链接',
    auto_138_afe8814b: '外部链接',
    auto_139_3e9cf0db: '图片广告',
    auto_139_fe1e30e4: '图片导航',
    auto_140_8a3667c7: '拖动选中的导航可对其排序',
    auto_141_6c3240d9: '固定',
    auto_142_ce4845ab: '点击添加图片',
    auto_143_291e5905: '样式三',
    auto_143_8b644417: '内部链接',
    auto_144_2e5a1856: '外部链接',
    auto_145_fc8451c9: '显示',
    auto_147_12a0fb3b: '显示',
    auto_147_83c3e7b8: '采购金额',
    auto_148_b7220f0c: '实付金额',
    auto_149_4e1fcefb: '方案二运费预付',
    auto_149_b8ae9af9: '显示',
    auto_151_e6478584: '无边白底',
    auto_152_35641460: '',
    auto_152_7819c2cf: '卡片投影',
    auto_153_6dc7a4dc: '描边白底',
    auto_154_b90eeb18: '无边透明底',
    auto_155_362485d0: '鼠标拖拽调整商品顺序',
    auto_155_d4ce2cfe: '大图模式',
    auto_156_83ec52fd: '一行两个',
    auto_157_258d6836: '一行三个',
    auto_157_ced864cd: '点击添加商品',
    auto_158_15475824: '详细列表',
    auto_158_c1ed9b07: '添加商品分组',
    auto_159_1ab4c4e6: '鼠标拖拽调整分组顺序',
    auto_159_f61a0ab5: '一大两小',
    auto_160_1b145402: '点击添加商品',
    auto_160_33d8ef3f: '横向滑动',
    auto_161_1d135fe4: '更换图片',
    auto_161_e28f6ced: '新品',
    auto_162_c13a6592: '清空图片',
    auto_163_4adbf233: '右下',
    auto_163_da664320: '图片广告',
    auto_164_91fcbc07: '拖动选中的导航可对其排序',
    auto_166_e5692185: '点击添加图片',
    auto_167_1e397a1f: '样式三',
    auto_167_ef6a4dce: '分组',
    auto_168_39c0e6ef: '横向滑动',
    auto_171_0a1546e8: '图片广告',
    auto_172_0f482ed0: '拖动选中的导航可对其排序',
    auto_174_756428f4: '一行二个',
    auto_174_8d034751: '点击添加图片',
    auto_175_0910f3f5: '样式三',
    auto_175_56efd339: '一行三个',
    auto_176_448098ad: '一行四个',
    auto_177_0ec2a2f9: '二左二右',
    auto_178_8172d6c2: '一左二右',
    auto_179_07abf4f5: '一上二下',
    auto_179_71c7a446: '运费',
    auto_180_263ed7bb: '实付金额',
    auto_180_6d92ed35: '一左三右',
    auto_181_2f47ecd4: '内部链接',
    auto_181_f43952fb: '采购金额',
    auto_182_19566a20: '外部链接',
    auto_182_b06ed898: '实付金额',
    auto_183_314d8e1d: '一左三右',
    auto_183_bd0c8844: '支持jpgpng格式最佳尺寸',
    auto_184_b68fb5c2: '凭证实例',
    auto_185_1f46ba2d: '支付',
    auto_186_88a9b233: '支付',
    auto_187_8434ac96: '使用微信扫一扫',
    auto_189_aec5533f: '支付',
    auto_190_129ab638: '使用支付宝扫一扫',
    auto_190_4bfb417c: '一行一个',
    auto_191_ff1cbeb7: '轮播海报',
    auto_192_0bca3c45: '二维码地址不正确',
    auto_192_cbb3d8a7: '多图单行',
    auto_193_4fec09ce: '对公转账',
    auto_193_69fe8e0b: '立体轮播',
    auto_194_1e880e51: '内部链接',
    auto_194_a5ebb961: '立即充值',
    auto_195_29a2a0d0: '外部链接',
    auto_195_e8fdcebd: '使用支付宝扫一扫',
    auto_196_a5c0c783: '导航横向滑动',
    auto_196_c0f4727d: '使用微信扫一扫',
    auto_197_bba92391: '二维码地址不正确',
    auto_198_001d1ca7: '充值成功',
    auto_201_f39f2c7c: '一行一个',
    auto_202_e1df8ae2: '轮播海报',
    auto_203_11d73e79: '多图单行',
    auto_204_0ca2eced: '立体轮播',
    auto_205_4c88b486: '内部链接',
    auto_206_fa76f700: '外部链接',
    auto_207_9fb081bd: '导航横向滑动',
    auto_211_deed34c7: '样式三',
    auto_212_4503564c: '样式一',
    auto_213_58061322: '样式二',
    auto_214_1082a64e: '样式三',
    auto_214_3336d015: '外部链接',
    auto_215_67625bb7: '样式四',
    auto_216_388b91ad: '背景图片',
    auto_216_cbf8c407: '样式五',
    auto_217_257b91c3: '建议尺寸',
    auto_217_e38e454c: '上方',
    auto_218_58caab8c: '更换图片',
    auto_218_9a3067d4: '下方',
    auto_219_73f2d631: '店铺头像',
    auto_219_8869a09b: '显示',
    auto_220_53a18a03: '更换图片',
    auto_221_7765c9c3: '显示',
    auto_223_37242506: '显示',
    auto_225_9b20333f: '显示',
    auto_226_617d2ffb: '运费',
    auto_227_83a6eea2: '实付金额',
    auto_227_ceb82976: '显示',
    auto_228_0a0ca324: '支付方式',
    auto_229_557e21d9: '对公转账',
    auto_229_9de0f846: '显示',
    auto_230_1168dd53: '支付',
    auto_231_84457b4b: '内部链接',
    auto_231_c487af43: '样式三',
    auto_232_86bacd9f: '外部链接',
    auto_233_666311fc: '无边白底',
    auto_234_bde23ce6: '卡片投影',
    auto_234_db2690ba: '外部链接',
    auto_235_0ce28284: '描边白底',
    auto_236_174a0711: '背景图片',
    auto_236_3e34fb8a: '无边透明底',
    auto_237_50875be3: '建议尺寸',
    auto_237_ca96c211: '大图模式',
    auto_238_e2bd33a4: '更换图片',
    auto_238_e9fbdf6d: '一行两个',
    auto_239_3622cba0: '横向滑动',
    auto_239_d278c58b: '店铺头像',
    auto_240_33d5a33e: '更换图片',
    auto_240_4cc2cc6e: '一大两小',
    auto_241_52383449: '详细列表',
    auto_241_f85bb3b7: '下级代理商',
    auto_242_31de822c: '新品',
    auto_244_5edba653: '内部链接',
    auto_244_9d956674: '请选择代理商',
    auto_245_7e73cd21: '下级代理商',
    auto_245_aa7a96f9: '外部链接',
    auto_246_d56d107e: '这里显示笔记标题最多',
    auto_247_94287073: '横向滑动',
    auto_248_22f06bf6: '请选择代理商',
    auto_249_2bd9ac7e: '如您需要转入此类学员进行服务需要提交审核后待省代同意后方能转',
    auto_251_45cf4f1a: '请上传督学服务购买凭证和与家长的沟通记录',
    auto_252_0fa164da: '点击上传图片',
    auto_253_2d63a546: '选中时',
    auto_253_9223791a: '活码是用户推广个人微信号或粉丝群的二维码适用于线上线下吸引用',
    auto_255_3d79d4c2: '更换图片',
    auto_255_e2e12c71: '内部链接',
    auto_256_1856931b: '外部链接',
    auto_256_e084ac2b: '更换图片',
    auto_257_4e50690b: '拖动选中的导航可对其排序',
    auto_257_7db1b71e: '书籍',
    auto_258_6c743df7: '点击添加导航',
    auto_258_d996f1e4: '其他',
    auto_259_ec3152a9: '更换图片',
    auto_259_fb3017dd: '正在搜索中',
    auto_260_814044fe: '清空图片',
    auto_260_c50c825c: '测试',
    auto_261_8c9ef40e: '测试',
    auto_261_cc8cd318: '显示',
    auto_262_2a868194: '小圆点',
    auto_262_a7b4945a: '暂无数据',
    auto_263_1e2ac1cf: '点击取消后您填写的信',
    auto_263_27550dc5: '最多添加',
    auto_264_fc834024: '暂未设置',
    auto_265_2be97a89: '未设置',
    auto_265_edec6409: '注意被设置为紧急联系人的账号将在极少数一般一个月不超过',
    auto_267_825914e3: '选择员工',
    auto_268_670ff28c: '无需设置紧急联系人点击右侧按钮取消提醒',
    auto_269_def5443e: '获取验证码',
    auto_269_e283a2e6: '未设置',
    auto_270_57fefe83: '重新获取验证码',
    auto_271_2d5d3117: '获取验证码',
    auto_272_4a32ae17: '重新获取验证码',
    auto_273_0e2e46fd: '如今天是第几次跟进讲解了松鼠Ai的优势等学员的意向科目是什么',
    auto_273_aeb07a52: '获取紧急联系人列表失',
    auto_274_b45d5bf5: '未设置',
    auto_275_d188a12c: '支持jpgpng格式最佳尺寸',
    auto_276_fc4e9f0c: '凭证实例',
    auto_277_6784f2d4: '有多个督学师的学生移除后状态保持不变',
    auto_277_db75769c: '紧急联系人',
    auto_280_267d7726: '个正式学员',
    auto_281_18a00695: '活码是用户推广个人微信号或粉丝群的二维码适用于线上线下吸引用',
    auto_283_73880d23: '更换图片',
    auto_284_1873ffa7: '更换图片',
    auto_285_a5a7f524: '拖动选中的导航可对其排序',
    auto_285_c5128c5f: '提交成功',
    auto_286_6157bbfa: '点击添加导航',
    auto_286_e806378c: '提交失败',
    auto_287_6a946063: '更换图片',
    auto_287_849374aa: '未设置',
    auto_288_5ef2f268: '清空图片',
    auto_289_f4701e29: '显示',
    auto_290_c4d797dd: '小圆点',
    auto_291_1815f84f: '最多添加',
    auto_293_be89a148: '关联代理账户余额',
    auto_295_6e62aa26: '请选择以下支付方式支',
    auto_296_0041b2e3: '凭证实例',
    auto_296_8f6d4c1d: '收费项目',
    auto_297_8abf3e2d: '单价',
    auto_298_2da831cc: '数量',
    auto_298_fe25fbec: '支付',
    auto_299_39663d85: '鼠标拖拽调整热词顺序搜索框默认展示第一个热词其他搜索词将以标',
    auto_299_d9edcab4: '金额',
    auto_300_6fd6255e: '折扣',
    auto_301_1c75938c: '优惠后的金额',
    auto_301_c2563ff7: '点击添加热词',
    auto_302_6d7b34a0: '页面设置',
    auto_302_f5bb943f: '保费',
    auto_303_83ed12ab: '更换图片',
    auto_303_c3435521: '请勿操作过于频繁',
    auto_304_52a4dfe7: '发货成功',
    auto_304_6c755347: '清空图片',
    auto_305_1d5f092c: '鼠标拖拽调整卡片顺序',
    auto_305_69f78632: '发货失败',
    auto_306_24dad104: '付款失败',
    auto_307_c7ba6fe0: '点击添加卡片',
    auto_307_d9629eda: '付款失败',
    auto_308_09f5aa98: '江西省景德镇市乐平市',
    auto_308_332d11c0: '',
    auto_309_6b77f0cb: '江西省景德镇市乐平市',
    auto_310_ae6106e0: '江西省景德镇市乐平市',
    auto_311_473f5dd4: '鼠标拖拽调整热词顺序搜索框默认展示第一个热词其他搜索词将以标',
    auto_311_b94dbcd5: '江西省景德镇市乐平市',
    auto_312_86afba2d: '江西省景德镇市乐平市',
    auto_313_2ae58c99: '江西省景德镇市乐平市',
    auto_313_bded05d1: '点击添加热词',
    auto_314_28785eab: '页面设置',
    auto_314_33f1fe82: '江西省景德镇市乐平市',
    auto_315_75feb9f2: '更换图片',
    auto_315_e5039ea1: '江西省景德镇市乐平市',
    auto_316_6dbd0403: '江西省景德镇市乐平市',
    auto_316_b1bdd575: '清空图片',
    auto_317_2b0717ec: '鼠标拖拽调整卡片顺序',
    auto_317_9da5b447: '江西省景德镇市乐平市',
    auto_318_bdf9a706: '支付成功',
    auto_319_acd760be: '点击添加卡片',
    auto_320_2f13c686: '底部导航组件为固定页面底部无需拖拽调整位置',
    auto_320_6d7330ec: '收费项目',
    auto_321_fd898be3: '单价',
    auto_322_bc3aabef: '数量',
    auto_322_d314fa61: '下拉框单选多选等文本用符号隔开如男女',
    auto_323_3ed4e1a5: '金额',
    auto_323_85f1a958: '点击添加内容',
    auto_324_01103e8f: '折扣',
    auto_324_45261ca8: '更换验证手机',
    auto_325_b684f2f3: '优惠后的金额',
    auto_325_eb3c8bdb: '获取验证码',
    auto_326_53b37252: '保费',
    auto_327_042286c8: '请勿操作过于频繁',
    auto_328_13128576: '底部导航组件为固定页面底部无需拖拽调整位置',
    auto_328_dae8e444: '付款失败',
    auto_329_f7e1aacc: '付款失败',
    auto_330_bece925e: '付款失败',
    auto_330_cf582917: '下拉框单选多选等文本用符号隔开如男女',
    auto_331_d23bf377: '点击添加内容',
    auto_332_a808c5c0: '导出报表',
    auto_333_6802f7cf: '导出报表',
    auto_334_227d711b: '导出报表',
    auto_335_f142092c: '输出',
    auto_336_6ffb1d8c: '微信支付',
    auto_336_898d3792: '下载导入模板',
    auto_338_aa1e2682: '付款失败',
    auto_339_3c3af093: '获取验证码',
    auto_339_ed5ecea7: '付款失败',
    auto_340_0c616071: '上传公众号图片',
    auto_340_b4c0b3fb: '付款失败',
    auto_342_c9c920ec: '本次支付将扣除',
    auto_342_c9f03726: '督学结束时间的次日客',
    auto_343_12743d28:
      '您当前登录的松鼠Ai账号由于长时间未登录存在安全风险，已进入冻结状态，如需继续使用您可进行账号唤醒操作。',
    wakeDialogDeferLogin: '暂不登录',
    wakeDialogWakeNow: '立即唤醒',
    wakeDialogDeferHandle: '暂不处理',
    wakeDialogConfirmed: '已确认',
    wakeDialogSecondMessage:
      '您ID{campusId}下的松鼠Ai账号正在被唤醒，请前往1{phone}注册的钉钉同意团队邀请确认加入总部。',
    auto_343_1d32944f: '确定',
    auto_344_1fc6be2a: '该账号已经长期未使用为了该账号的安全请保存如下二维码发送给家',
    auto_344_b8289acd: '请选择督学到期时间',
    auto_345_b57279bb: '请选择督学门店',
    auto_345_e6900270: '确认发布',
    auto_346_8759d587: '姓名',
    auto_346_e7105895: '上传公众号图片',
    auto_347_221bceee: '阶段年级',
    auto_348_7338083d: '学习中心账号',
    auto_349_d9ef97f6: '服务人员',
    auto_350_a8adb4c9: '个月',
    auto_351_e566f31d: '个月',
    auto_352_eea985db: '个月',
    auto_353_fab3648e: '个月',
    auto_354_fd84dda6: '学前',
    auto_355_b4384eb6: '小学',
    auto_356_170c6c31: '初中',
    auto_357_9e7d394b: '高中',
    auto_358_de3dbeff: '小班',
    auto_359_e011300b: '中班',
    auto_360_cd722ca1: '大班',
    auto_361_694fc5e7: '一年级',
    auto_362_4df5bd40: '二年级',
    auto_363_7373adfb: '三年级',
    auto_364_59a9aa58: '四年级',
    auto_365_01ad86b3: '五年级',
    auto_366_8ce6b148: '六年级',
    auto_367_6ec28ee8: '六年级',
    auto_368_0431dfa1: '七年级',
    auto_369_d05aef19: '八年级',
    auto_370_dc32dacc: '九年级',
    auto_371_391d9d87: '高一',
    auto_372_b7098df1: '高二',
    auto_373_1888db71: '高三',
    auto_374_259e9142: '高四',
    auto_375_1177b2b7: '保存失败',
    auto_376_b56ca628: '保存失败',
    auto_384_0c33fbe1: '客户当前访问账号组织',
    auto_385_64f70ee4: '客户访问账号组织性质',
    auto_386_bc3579ad: '客户访问账号级别',
    auto_387_5f606fef: '客户访问账号全部组织',
    auto_389_c72ec969: '已完结',
    auto_398_5ad9a814: '确认移除体验学员',
    auto_400_4e3209c7: '确认移除学员',
    auto_401_da364415: '确认移除体验学员',
    auto_402_78775655: '确认移除学员',
    auto_403_94fa966b: '当前督学师',
    auto_404_83e062bf: '当前状态',
    auto_405_24ed0186: '辅助空白',
    auto_407_33f9cbe0: '无边距',
    auto_409_dfd0e873: '实线',
    auto_410_09f7a574: '虚线',
    auto_411_a379b0d5: '点线',
    auto_412_bdbd15b7: '显示',
    auto_414_0e7d6384: '显示',
    auto_416_9a85b398: '正常模式',
    auto_418_24814915: '正常模式',
    auto_420_9ff9fd92: '方形',
    auto_422_06c31f6d: '方形',
    auto_424_e8d3fde8: '居左',
    auto_426_8c38f1b5: '居左',
    auto_428_4420ad6e: '显示',
    auto_430_dab76579: '显示',
    auto_432_d26c4e85: '显示',
    auto_434_4bce51c1: '默认颜色',
    auto_435_6682f6af: '默认颜色',
    auto_436_da266f2e: '更换',
    auto_438_c0a7db5f: '内部链接',
    auto_439_c678cd52: '外部链接',
    auto_440_e1702282: '图片导航',
    auto_442_4ed3efd7: '固定',
    auto_444_5cc58cb9: '内部链接',
    auto_445_ec6fdc11: '外部链接',
    auto_446_c3174bd3: '显示',
    auto_448_2a8a960e: '显示',
    auto_450_d4529d4d: '显示',
    auto_452_bddb8735: '请输入有效数字',
    auto_453_82b92fb0: '无边白底',
    auto_454_57eaab2b: '卡片投影',
    auto_455_21dc0c87: '描边白底',
    auto_456_7ede69e7: '无边透明底',
    auto_457_b3d1b2a7: '大图模式',
    auto_458_03989da0: '一行两个',
    auto_459_e60df26f: '一行三个',
    auto_460_93588292: '详细列表',
    auto_461_e3a3762e: '一大两小',
    auto_462_64a950fe: '横向滑动',
    auto_463_c29b0da2: '新品',
    auto_465_12701329: '右下',
    auto_469_a412f003: '分组',
    auto_470_f9cccea9: '横向滑动',
    auto_476_493a15f7: '一行二个',
    auto_477_045aa7df: '一行三个',
    auto_478_ef701ad0: '一行四个',
    auto_479_d9c11a16: '二左二右',
    auto_480_a6cc2d22: '一左二右',
    auto_481_d115a9bb: '一上二下',
    auto_482_54da05b9: '一左三右',
    auto_483_67431e6a: '内部链接',
    auto_484_be9ac87b: '外部链接',
    auto_485_e18fc47d: '一左三右',
    auto_492_c72b1e91: '一行一个',
    auto_493_46a12ceb: '轮播海报',
    auto_494_2cdb57d7: '多图单行',
    auto_495_55b86c61: '立体轮播',
    auto_496_e145b007: '内部链接',
    auto_497_239efe19: '外部链接',
    auto_498_ba1aa155: '导航横向滑动',
    auto_503_a0e7e7ae: '一行一个',
    auto_504_4c4cb749: '轮播海报',
    auto_505_008e901e: '多图单行',
    auto_506_ad2fb054: '立体轮播',
    auto_507_a4371648: '内部链接',
    auto_508_0257f830: '外部链接',
    auto_509_29c74c2c: '导航横向滑动',
    auto_514_8b199476: '样式一',
    auto_515_693eed0f: '样式二',
    auto_516_d5f718b9: '样式三',
    auto_517_55c62973: '样式四',
    auto_518_8c050296: '样式五',
    auto_519_9158c62d: '上方',
    auto_520_e62cf834: '下方',
    auto_521_03942fb2: '显示',
    auto_523_e85c1c82: '显示',
    auto_525_60157788: '显示',
    auto_527_2cf835ed: '显示',
    auto_529_32a3367d: '显示',
    auto_531_db197713: '显示',
    auto_533_ff7f57b6: '内部链接',
    auto_534_eafaa13f: '外部链接',
    auto_535_45dba234: '无边白底',
    auto_536_d8d41d1a: '卡片投影',
    auto_537_200e510a: '描边白底',
    auto_538_3a99fd16: '无边透明底',
    auto_539_c06bd7aa: '大图模式',
    auto_540_997720bf: '一行两个',
    auto_541_a5a5eb74: '横向滑动',
    auto_542_3c169032: '一大两小',
    auto_543_9d579d33: '详细列表',
    auto_544_a5ef145f: '新品',
    auto_546_466f0afa: '内部链接',
    auto_547_94cf8395: '外部链接',
    auto_548_26ce1760: '这里显示笔记标题最多',
    auto_549_54c8c4c1: '横向滑动',
    auto_555_5e2685e6: '选中时',
    auto_557_214410b4: '内部链接',
    auto_558_b8fa4fd9: '外部链接',
    auto_559_0e34e723: '删除图片',
    auto_560_ba0ce9b2: '替换图片',
    auto_561_92f2a573: '删除图片',
    auto_562_b74e0f54: '替换图片',
    auto_563_1783ae38: '删除图片',
    auto_564_41406e8c: '替换图片',
    auto_565_b0330cfc: '删除图片',
    auto_566_e94396a0: '替换图片',
    auto_567_77dc8773: '删除图片',
    auto_568_bc16c2f5: '替换图片',
    auto_569_4ddb639b: '天内将会有工作人员联',
    auto_570_6c22cb12: '请选择活动开始结束时',
    auto_571_717a46b6: '活动说明图片',
    auto_572_45c0748d: '活动规则图片',
    auto_573_b11b7ea1: '机构介绍图片',
    auto_574_83746af1: '机构介绍图片',
    auto_575_08a98c36: '二维码图片',
    auto_576_be030eaf: '取消',
    auto_606_a265e358: '小班',
    auto_607_7145c0e4: '中班',
    auto_608_0af2214b: '大班',
    auto_609_f9520c05: '一年级',
    auto_610_3461ac27: '二年级',
    auto_611_955dc562: '三年级',
    auto_612_d012d922: '四年级',
    auto_613_ca3746b3: '五年级',
    auto_614_a8846a79: '六年级',
    auto_615_20c6c458: '六年级',
    auto_616_c6723b3c: '七年级',
    auto_617_770f4de9: '八年级',
    auto_618_e0a5ada8: '九年级',
    auto_619_a94c2ddd: '高一',
    auto_620_5a44415e: '高二',
    auto_621_ced1e3d8: '高三',
    auto_622_2b7e2b9c: '高四',
    auto_623_77451e5c: '已成交',
    auto_629_0678b836: '发起呼叫',
    auto_630_10a00a86: '接通坐席',
    auto_631_c32f7c23: '坐席振铃',
    auto_632_c3c6c0b6: '正在接通中',
    auto_633_3d13bc80: '通话结束',
    auto_634_f6020e93: '坐席空闲',
    auto_635_820490f6: '正在呼叫',
    auto_636_10cc60c3: '正在播放工号',
    auto_637_4718bdad: '坐席接听',
    auto_638_f7a633c5: '通话中',
    auto_639_4e4da016: '此项必填',
    auto_640_2494517e: '全选',
    auto_641_5b463606: '文本',
    auto_645_ce07e488: '文本',
    auto_649_5399102b: '禁用',
    auto_652_df79d2f5: '测试',
    auto_653_9d8f1deb: '测试',
    auto_654_bf5fe59a: '全选',
    auto_655_e2d64fef: '下一步',
    auto_657_51fb12ea: '验证成功',
    auto_658_966426c5: '验证失败',
    auto_666_60482caa: '内部链接',
    auto_667_d7dcb490: '外部链接',
    auto_668_728b44d2: '下一步',
    auto_670_c8e36f07: '验证码错误',
    auto_671_29db97da: '验证码错误',
    auto_672_eaf04f12: '内部链接',
    auto_673_653949d5: '外部链接',
    auto_676_c665a636: '含第一季度业绩',
    auto_677_2371f4ab: '含第一二季度业绩',
    auto_678_3edc269e: '含第一二三季度业绩',
    auto_679_70568fa5: '取消',
    auto_682_2a8ac5dc: '上传图片失败请删除后',
    auto_683_79283b19: '仅支持或格式的文件',
    auto_684_28a14bbf: '请上传图片',
    auto_685_93ba3225: '请重新上传',
    auto_686_67ae8165: '继续学习',
    auto_688_d90ce707: '请求失败',
    auto_689_706fbc91: '请求失败',
    auto_690_faf9e4bc: '底部导航',
    auto_691_87642a19: '您的账号已禁用请联系',
    auto_692_698b1db8: '您的账号已禁用请联系',
    auto_693_bd7f79f4: '唤醒成功',
    auto_694_777ce4cd: '唤醒失败请稍后重试',
    auto_695_6db324bb: '唤醒失败请稍后重试',
    auto_696_a5dbd8c2: '底部导航',
    auto_697_23f1290c: '图片加载失败',
    auto_698_780dddcd: '云仓商品库存统计',
    auto_699_a53fe93d: '云仓仓库库存统计',
    auto_702_48c87ede: '金额',
    auto_704_ff0bd18a: '自定义课程产品',
    auto_705_0210c642: '商品名称',
    auto_706_b21df977: '充值业绩',
    auto_709_b58a2367: '确认',
    auto_711_23695f4b: '采购中心',
    auto_712_ea6f60e7: '限制原因',
    auto_1733_2683badf: '为避免耽误您的外呼业务开展根据您选择的开通月数到期后默认',

    auto_13_c84c9c0a: '对应的代理商账户和调整对应期货订单额度',
    auto_22_19c4a75b: '可随时关闭',
    auto_25_3e832b4e: '可随时关闭',
    auto_27_d1819be1: '支持退费',
    auto_45_303e37ca: '或同等比例',
    auto_47_2b37eaea: '或同等比例',
    auto_49_ce69d168: '或同等比例',
    auto_51_548e1408: '或同等比例',
    auto_53_df52d236: '或同等比例',
    auto_55_8a473108: '或同等比例',
    auto_57_23073796: '支付失败',
    auto_57_92251487: '或同等比例',
    auto_58_b95fd9b8: '',
    auto_59_e3ad33aa: '或同等比例',
    auto_72_dea16466: '取消',
    auto_74_4a659629: '提交申请',
    auto_90_9e04fb76: '或同等比例',
    auto_92_bb9c70b9: '或同等比例',
    auto_94_5ae0dde8: '或同等比例',
    auto_96_bd0583a6: '或同等比例',
    auto_98_e7619100: '或同等比例',
    auto_100_675c965a: '或同等比例',
    auto_101_34344d00: '申请提交成功',
    auto_102_74f23393: '或同等比例',
    auto_103_8969963d: '',
    auto_104_6164b9f8: '或同等比例',
    auto_105_591eb1d9: '辅助线',
    auto_107_cd7d6781: '左右留边',
    auto_112_62e20aa3: '隐藏',
    auto_114_2ea46504: '隐藏',
    auto_116_b284796a: '滚动至顶部固定',
    auto_118_eef46fd3: '滚动至顶部固定',
    auto_120_46ee5cef: '圆形',
    auto_122_151d2f40: '其他设置',
    auto_122_3ea10287: '圆形',
    auto_124_87dc5816: '居中',
    auto_126_5c36ac58: '居中',
    auto_128_5ddcf2f1: '隐藏',
    auto_130_5c3e8624: '隐藏',
    auto_132_5e227d58: '隐藏',
    auto_136_2294e589: '添加',
    auto_140_0eebdadc: '文字导航',
    auto_142_94863036: '滑动',
    auto_146_4655a856: '隐藏',
    auto_148_bacaf968: '隐藏',
    auto_150_bde0d922: '隐藏',
    auto_162_c3fd44e9: '热卖',
    auto_220_54b5b650: '隐藏',
    auto_222_e9e6d827: '隐藏',
    auto_224_02f8bbea: '隐藏',
    auto_226_11e4fbb7: '隐藏',
    auto_228_dd3abf83: '隐藏',
    auto_230_def5ae4f: '隐藏',
    auto_243_da467e81: '热卖',
    auto_254_7d9cf14b: '添加好友或粉丝群进行长期维护的场景',
    auto_254_7de05314: '未选中时',
    auto_274_f55c1464: '家长态度如何是否预约下次跟进等',
    auto_278_a241fe24: '未设置',
    auto_279_63ad186a: '未设置',
    auto_280_4eee9e17: '未设置',
    auto_282_39e5777b: '添加好友或粉丝群进行长期维护的场景',
    auto_288_2ce03110: '未设置',
    auto_289_78eeb1e3: '未设置',
    auto_294_7ef954c4: '账户余额',
    auto_319_e0bf7ef9: '支付失败',
    auto_390_9c90503b: '处理中',
    auto_399_0204a557: '确认移除学员',
    auto_406_eecda0aa: '辅助线',
    auto_408_b0824788: '左右留边',
    auto_413_f27eec55: '隐藏',
    auto_415_240b2d57: '隐藏',
    auto_417_f073eed7: '滚动至顶部固定',
    auto_419_88173eb3: '滚动至顶部固定',
    auto_421_5ba55c51: '圆形',
    auto_423_6c5c9370: '圆形',
    auto_425_8e22d440: '居中',
    auto_427_9c8d6a58: '居中',
    auto_429_de755e1b: '隐藏',
    auto_431_5104032f: '隐藏',
    auto_433_c3a3b8cb: '隐藏',
    auto_437_c4a7674a: '添加',
    auto_441_90304804: '文字导航',
    auto_443_34b8c7da: '滑动',
    auto_447_5808f99a: '隐藏',
    auto_449_8d994a06: '隐藏',
    auto_451_5b38e481: '隐藏',
    auto_464_49011ed5: '热卖',
    auto_522_35bd42cb: '隐藏',
    auto_524_2d5c1fe7: '隐藏',
    auto_526_0f5d35fe: '隐藏',
    auto_528_32dfabf2: '隐藏',
    auto_530_9e8bd9c0: '隐藏',
    auto_532_b58d720f: '隐藏',
    auto_545_f6c84cd4: '热卖',
    auto_556_88c3b588: '未选中时',
    auto_642_6743fcff: '下拉框',
    auto_643_3d809b1a: '单选',
    auto_644_48a91d08: '多选',
    auto_646_0ff92362: '下拉框',
    auto_647_e67df2d0: '单选',
    auto_648_3fc04390: '多选',
    auto_669_6e573553: '确定',
    auto_687_479f10d7: '开始学习',
    auto_703_44431f13: '税额',
    auto_707_8c582976: '赊货订单未完款业绩',
    auto_708_3447fc64: '小计',

    auto_2_7eac2f18: '上海',
    auto_3_d02b13ac: '普陀区',
    auto_4_3d251ca5: '上海市普陀区金沙江路',
    auto_16_649497cd: '开通使用协议',
    auto_29_1b861332: '开通使用协议',
    auto_37_e5314cea: '开通使用协议',
    auto_40_7eb7a046: '选定布局区域在下方添加图片',
    auto_61_423ca5e1: '下一步',
    auto_64_794b0be6: '工单是您咨询客服时因为问题难度等原因无法为您解答',
    auto_64_b77421ef: '更换手机号绑定新手机',
    auto_65_2b441bf0: '将会提交工单给技术专家进行处理',
    auto_77_49a3410c: '情况说明长度为字',
    auto_82_f114b59f: '跨主体督学申请详情',
    auto_83_ecad14f2: '审核跨主体督学申请',
    auto_85_0c6b2447: '选定布局区域在下方添加图片',
    auto_92_1364e0d6: '审核通过',
    auto_93_7dd3aeb1: '审核拒绝',
    auto_96_0d7118c4: '本月已使用额度未超限',
    auto_97_daafa233: '您的跨主体设备学员已',
    auto_98_ed78a387: '申请已审核无需重复提',
    auto_109_d9791baa: '限制',
    auto_124_6bb36468: '鼠标拖拽调整商品顺序',
    auto_133_76b3a166: '拖动选中的导航可对其排序',
    auto_136_ae72634b: '样式一',
    auto_137_72ab3cd3: '样式二',
    auto_138_cd7bbb31: '样式三',
    auto_141_23df5fea: '拖动选中的导航可对其排序',
    auto_144_1d0b82ae: '样式一',
    auto_145_a5f5d11b: '样式二',
    auto_146_f57c1990: '样式三',
    auto_151_a1b97406: '方案二运费预付',
    auto_156_0bd8a165: '鼠标拖拽调整商品顺序',
    auto_164_f34f97e7: '左下',
    auto_165_57d50e6d: '右上',
    auto_165_cb52650a: '拖动选中的导航可对其排序',
    auto_166_5ccc47bb: '右下',
    auto_168_fb5bb7e0: '样式一',
    auto_169_2f49db28: '一行两个',
    auto_169_58cf2c9b: '样式二',
    auto_170_242cafcd: '一行三个',
    auto_170_64e5757f: '样式三',
    auto_171_1a54ab1c: '详细列表',
    auto_172_178edd16: '一大两小',
    auto_173_1d26645d: '横向滑动',
    auto_173_6de5a213: '拖动选中的导航可对其排序',
    auto_176_c98855c4: '样式一',
    auto_177_e58eb258: '样式二',
    auto_178_889a8746: '样式三',
    auto_184_c98f401b: '一行三个',
    auto_185_0fcd7d54: '一行四个',
    auto_186_ff05b364: '二左二右',
    auto_187_2759dbce: '一左二右',
    auto_188_6a461e5c: '使用支付宝扫一扫',
    auto_188_99efaa5e: '一上二下',
    auto_189_01862b77: '一左三右',
    auto_191_60623d74: '使用微信扫一扫',
    auto_197_8c7486a0: '轮播海报',
    auto_198_a2b3464e: '多图单行',
    auto_199_08498f60: '立体模式',
    auto_200_b99e418f: '导航横向滑动',
    auto_208_d13dc59b: '轮播海报',
    auto_209_2c4fec4d: '多图单行',
    auto_210_16fe9f08: '立体模式',
    auto_211_f6dbd0e5: '导航横向滑动',
    auto_212_c3e03ebe: '样式二',
    auto_213_d38d7b93: '样式三',
    auto_215_f2333149: '外部链接',
    auto_232_60867bd9: '样式二',
    auto_233_80caa70c: '样式三',
    auto_235_92ff4fd0: '外部链接',
    auto_242_bcb964f8: '上级代理商',
    auto_243_cbaa4988: '下级代理商',
    auto_246_b2f63ebb: '上级代理商',
    auto_247_f643a94e: '下级代理商',
    auto_248_6bd6c0a1: '一行两个',
    auto_249_9cc46fdf: '横向滑动',
    auto_250_de88cced: '如您需要转入此类学员进行服务需要提交审核后待省代同意后方能转',
    auto_250_f993b2e0: '详细列表',
    auto_251_9865162c: '一大两小',
    auto_252_6d59eded: '横向滑动',
    auto_266_16011053: '未设置',
    auto_267_38444dd7: '未设置',
    auto_268_eb95a4e9: '未设置',
    auto_270_d8e63225: '未设置',
    auto_271_2affd119: '未设置',
    auto_272_1f9e7cf3: '未设置',
    auto_275_08ad640c: '未设置',
    auto_276_e3c7f90a: '未设置',
    auto_278_3c291386: '仅有当前督学师的学生移除后状态会变更为不督学',
    auto_279_9d974559: '有多个督学师的学生移除后状态保持不变',
    auto_281_b8fe3ff8: '紧急联系人',
    auto_297_5ac2955d: '凭证实例',
    auto_300_021b8a8a: '鼠标拖拽调整热词顺序搜索框默认展示第一个热词其他搜索词将以标',
    auto_306_b941cedd: '鼠标拖拽调整卡片顺序',
    auto_312_be179ff5: '鼠标拖拽调整热词顺序搜索框默认展示第一个热词其他搜索词将以标',
    auto_318_0d696691: '鼠标拖拽调整卡片顺序',
    auto_321_9639feab: '底部导航组件为固定页面底部无需拖拽调整位置',
    auto_329_273c4816: '底部导航组件为固定页面底部无需拖拽调整位置',
    auto_337_27dee8c1: '微信支付',
    auto_466_fa9e1655: '左下',
    auto_467_eb6db3c3: '右上',
    auto_468_aac4b0f6: '右下',
    auto_471_2278d26d: '一行两个',
    auto_472_3334f53e: '一行三个',
    auto_473_de905509: '详细列表',
    auto_474_8809c76f: '一大两小',
    auto_475_0d4c933d: '横向滑动',
    auto_486_4897ff13: '一行三个',
    auto_487_248d92d0: '一行四个',
    auto_488_1da4df9a: '二左二右',
    auto_489_99d852bc: '一左二右',
    auto_490_620280ad: '一上二下',
    auto_491_aeeb07cb: '一左三右',
    auto_499_cbc5aec3: '轮播海报',
    auto_500_64bdcf34: '多图单行',
    auto_501_cf228456: '立体模式',
    auto_502_95717bc1: '导航横向滑动',
    auto_510_dee125db: '轮播海报',
    auto_511_ad01c8e0: '多图单行',
    auto_512_74b481d4: '立体模式',
    auto_513_a3961ff9: '导航横向滑动',
    auto_550_c251ad87: '一行两个',
    auto_551_9467c276: '横向滑动',
    auto_552_72134306: '详细列表',
    auto_553_47503a5b: '一大两小',
    auto_554_e61f75d1: '横向滑动',
    auto_578_fe32b009: '继续发布',
    auto_579_da6dbc03: '取消',
    auto_624_a921024f: '已加微',
    auto_625_6dbd04d4: '已诺访',
    auto_626_c3cdab96: '已到访',
    auto_627_2c036380: '已失效',
    auto_628_680ad587: '已成交',
    auto_650_ef08637d: '禁用',
    auto_656_2b7363ca: '下一步',
    auto_680_12d9e042: '确定',
    auto_681_0fd13602: '取消',
    auto_710_064217c6: '确认',
    auto_1724_16ad7868: '为避免眈误您的外呼业务开展根据您选择的开通月数到期后默认',

    auto_23_c7c89db7: '内完成商务对接及服务开通部分地区由于号码资源有限开通时间相对',
    auto_34_2e929559: '可随时关闭',
    auto_111_81f9bfcc: '支持jpgpnggif格式RGB模式不超过5M',
    auto_113_2e895df9: '支持jpgpnggif格式RGB模式不超过5M',
    auto_115_4001cd0b: '支持jpgpnggif格式RGB模式不超过5M',
    auto_117_f2e9b577: '支持jpgpnggif格式RGB模式不超过5M',
    auto_150_4c7871e5: '收货后支付给配送员实际金额可能会有20的浮动以实际为准',
    auto_153_c2ab8b22: '2预收到付运费自愿选择如果放弃预付运费所享受的折扣须在签收时',
    auto_154_426cde05: '3预收到付运费收取后如果此订单与其他订单合并配送满足免运费条',
    auto_264_96fec72b: '最多添加5个',
    auto_266_ec12174c: '注意被设置为紧急联系人的账号将在极少数一般一个月不超过3次的',
    auto_282_a4143e47: '未设置',
    auto_283_b21e743a: '未设置',
    auto_284_9b21a54d: '未设置',
    auto_292_537dcd1d: '最多添加5个',
    auto_309_6f93698c: '2预收到付运费自愿选择如果放弃预付运费所享受的折扣须在签收时',
    auto_310_26fb9fa5: '3预收到付运费收取后如果此订单与其他订单合并配送满足免运费条',
    auto_577_09100b8f: '敏感词检测',
    auto_651_fce225af: '正常',

  },
  // 服务中心
  serviceCenter: {
    coinMall: '金币商城',
    pickupStore: '自提商店',
    providePickupExchange: '提供自提商店商品兑换功能',
    pickupExchangeDesc: '启用自提商店商品兑换功能后，你的学员可以在自提商店进行下单',
    pickupStoreDisplaySetting: '自提商店展示设置',
    productName: '商品名称',
    enterProductName: '请输入商品名称',
    displaySwitchDesc: '展示开关（开启后会展示在自提商店）',
    productImage: '商品图片',
    exchangePrice: '兑换价格',
    operation: '操作',
    enableSuccess: '开启成功',
    disableSuccess: '关闭成功'
  },
  asEditor: {
    backActivityList: "返回活动列表",
    stepTitleBasicInfo: "活动基础信息",
    stepTitleMarketingMaterial: "营销素材上传",
    stepTitleReview: "页面效果复核",
    auto_1_59cf5f64: "查看操作教程",
    auto_1_8c920303: "页面标题",
    auto_2_5371635d: "重置",
    auto_2_6124d765: "图片广告",
    auto_3_a8990461: "页面设置",
    auto_3_e24c168e: "图片广告",
    auto_4_7ea01090: "组件管理",
    auto_4_f6e49da2: "图片广告",
    auto_5_02873c22: "松鼠限时活动",
    auto_5_7aecfac4: "组件设置",
    auto_6_bb452d56: "查看",
    auto_6_f2255260: "上一步",
    auto_7_3a6109f8: "确定",
    auto_7_afc01000: "使用通用模板",
    auto_8_7905777d: "编辑完成预览效果",
    auto_8_7ec6ee4e: "重置后您添加或者修改",
    auto_9_55efd481: "提示",
    auto_9_cf70301c: "预览",
    auto_10_3a85785f: "查看JSON",
    auto_10_9ae5ae83: "确定",
    auto_11_a9ede7c9: "取消",
    auto_11_c18162c3: "导入JSON",
    auto_12_1db9bee1: "导出JSON",
    auto_12_7f63d57a: "图片广告",
    auto_13_03ee8a72: "保存",
    auto_13_bc2aec5c: "图片广告",
    auto_14_33ef2ff7: "返回列表后，您添加或修改的内容将丢失",
    auto_14_febf0bcd: "iPhone8手机高度",
    auto_15_6200fa9c: "页面设置",
    auto_15_a2fa015c: "提示",
    auto_16_3a051693: "组件管理",
    auto_16_58d7a719: "确定",
    auto_17_0b3be60c: "组件设置",
    auto_17_eeac68a9: "取消",
    auto_18_50ea7734: "文本内容不能为空，请填写",
    auto_18_e1e54ae8: "填写建议不同的活动名称可用于精细化活动运营若您有多个门店或您",
    auto_19_75e96370: "开始日期",
    auto_19_dc443ba0: "不限时间",
    auto_20_d3ef25f3: "结束日期",
    auto_20_d74687a5: "指定时间",
    auto_21_37deb38e: "活动标题",
    auto_21_b741d0eb: "活动在微信中分享的卡片样式",
    auto_22_17d82179: "下一步",
    auto_22_9ec9bd6b: "活动描述",
    auto_23_46ad2b24: "活动名称",
    auto_23_90f5e9d6: "填写活动基础信息",
    auto_24_ddb80bb3: "上传活动营销素材",
    auto_24_f07cb5f2: "请输入活动名称",
    auto_25_5e199f9c: "活动时间",
    auto_25_fc33d4e0: "检查活动页面效果复核",
    auto_26_7c73ad47: "活动标题",
    auto_27_f0e1a8e1: "请输入活动标题",
    auto_28_e6311ab7: "活动描述",
    auto_29_658293df: "请输入活动描述",
    auto_30_3f85201e: "上一步",
    auto_31_5ba29762: "确认发布"
  },
  channelAgents: {
    auto_1_50f0c2f6: "线索状态",
    auto_1_bcc4eca0: "升级申请",
    auto_2_57e34a20: "首笔合同款奖励比例",
    auto_2_cf77705d: "申请时间",
    auto_3_1cd11945: "转介绍经销商续费奖励比例",
    auto_3_b8640dd0: "审核时间",
    auto_4_a361b8d8: "介绍人",
    auto_4_b6a2b355: "升级申请",
    auto_5_8edf6c66: "介绍代理商名称",
    auto_5_e3ef133a: "升级到",
    auto_6_c5d37c9b: "介绍人所在区域",
    auto_6_d48837f6: "请选择",
    auto_7_6370bfd0: "介绍人",
    auto_7_b3e1df51: "升级所需额度",
    auto_8_58f6b177: "当前级别",
    auto_8_c4154868: "介绍人电话",
    auto_9_31823765: "当前可用额度",
    auto_9_ff87ff59: "与客户沟通截图",
    auto_10_aec53ef9: "备注",
    auto_10_af593915: "奖励方式",
    auto_11_5f0a4c24: "当前渠道代级别",
    auto_11_d4e95212: "提现代理商",
    auto_12_216edddb: "状态",
    auto_12_26977aef: "提现代理商名称",
    auto_13_5a9f7023: "提交人代理商",
    auto_13_9842aea2: "a级",
    auto_14_d4a62bd1: "提交代理商名称",
    auto_14_f7a21f63: "b级",
    auto_15_c80f893e: "提交人所在区域",
    auto_16_9c37a83e: "客户姓名",
    auto_17_6fd3cb0e: "客户电话",
    auto_18_9bafa9cb: "客户所在区域",
    auto_19_71922b9a: "客户背景信息",
    auto_20_3d186f73: "跟进的拓展姓名",
    auto_21_94808661: "与拓展沟通截图",
    auto_22_a0bc721f: "审核意见",
    auto_23_36a06e97: "关联渠道代",
    auto_24_cedc8cdd: "关联渠道代名称",
    auto_25_23ad9f02: "状态",
    auto_26_7ecf0773: "周期",
    auto_27_efbff6d8: "代理商",
    auto_28_db1ffdb8: "股东名称",
    auto_29_a20083fa: "投资金额万元",
    auto_30_a849f541: "转介绍奖励",
    auto_31_c83c19fa: "松鼠",
    auto_32_7cfa5436: "松果",
    auto_33_f962ea2f: "补返",
    auto_34_5aacbc1f: "首次",
    auto_35_55d06364: "奖励类型",
    auto_36_5aacf3db: "点击确定后提交申请",
    channelAgentId: "渠道代ID",
    channelAgentName: "渠道代名称",
    currentChannelAgentLevel: "当前渠道代级别",
    cumulativeChannelAgentLevel: "累计渠道代级别",
    status: "状态",
    effectiveCycle: "有效期",
    applyTime: "申请时间",
    applicant: "申请人",
    auditOpinion: "审核意见",
    creator: "创建人",
    createTime: "创建时间",
    remark: "备注",
    equityInfo: "股权信息",
    agent: "代理商",
    shareholderName: "股东名称",
    investAmountWanYuan: "投资金额万元",
    relatedChannelAgent: "关联渠道代",
    relatedChannelAgentName: "关联渠道代名称",
    period: "周期",
    changeLog: "变更记录",
    pleaseSelectStatus: "请选择状态",
    applyStatusPendingReview: "待审核",
    applyStatusToBeSigned: "待签约",
    applyStatusInEffect: "生效中",
    applyStatusExpired: "已过期",
    applyStatusReturned: "审核未通过",
    applyStatusCancelled: "已取消",
    firstContractRewardRatio18: "首笔合同款奖励比例",
    levelA13: "A级",
    levelB14: "B级",
    levelC15: "C级",
    levelD16: "D级",
    // PerformanceManagement 业绩管理 — 表格列（勿与搜索项 customer 等混用）
    perfReferralCustomerId: "转介绍客户ID",
    perfReferralCustomerName: "转介绍客户名称",
    perfCustomerAccountOpenTime: "客户账户开通时间",
    perfAccountOpenTime: "账户开通时间",
    perfSource: "业绩来源",
    perfPleaseSelectRewardType: "请选择奖励方式",
    perfPleaseSelectSource: "请选择业绩来源",
    perfContractLastPayTime: "合同款末次支付时间",
    perfContractSignAmount: "签约金额",
    perfContractPaidAmountCol: "已付合同款金额",
    perfUsedQuota: "已使用额度",
    perfAvailableQuota: "可用额度",
    perfIntroducerId: "介绍人id",
    perfIntroducerName: "介绍人名称",
    perfWithdrawableAmount: "可提现金额",
    perfPayoutAgentId: "提现代理商ID",
    perfPayoutAgentName: "提现代理商名称",
    perfEffectiveAvailableTotal: "有效的可用额度合计：{amount}元",
    quotaUseType: "使用类型",
    quotaUseLevel: "升级到",
    quotaUseAmount: "使用额度",
    quotaUseRemark: "备注",
    quotaUseUser: "使用人",
    quotaUseTime: "使用时间",
    quotaUseIntroducerId: "介绍人ID",
    quotaUseIntroducerName: "介绍人代理名称",
    quotaUseDealerUpgrade: "经销商升级",
    quotaUseAgentDiscount: "代理商优惠",
    quotaUsePleaseSelectType: "请选择类型",
    regionCurrentChannelAgentLevel: "介绍人当前渠道代级别",
    regionCumulativeAgentLevel: "累计渠道代级别",
    regionPleaseSelectReferralCustomerId: "请选择转介绍客户ID",
    regionPleaseSelectLevel: "请选择级别",
    regionOrderAmount: "已下单金额",
    afpReferralCustomerId: "转介绍客户ID",
    afpReferralCustomerName: "转介绍客户名称",
    afpReferralContractAmount: "转介绍签约金额",
    afpPurchaseOrderNo: "采购单号",
    afpPaymentStatus: "支付状态",
    afpOrderStatus: "订单状态",
    afpProductName: "产品名称",
    afpPurchaseQuantity: "采购数量",
    afpDeliveryQuantity: "发货数量",
    afpPurchaseUnitPrice: "采购单价",
    afpPurchaseTotalAmount: "采购总金额",
    afpContractPaidAmount: "合同款支付金额",
    afpCumulativeReturnedAmount: "累计已返金额",
    afpDeliveryTime: "发货时间",
    afpRewardRate: "奖励比例",
    afpRewardAmount: "奖励金额",
    afpIsFirstTime: "是否首次",
    afpSettlementYearMonth: "结算年月",
    afpIntroducerOrChannelAgentId: "介绍人/渠道代ID",
    afpChannelAgentName: "渠道代名称",
    afpRegionalAgentId: "区代ID",
    afpRegionalAgentShareAmount: "区代分担金额",
    crfReferralCustomerId: "转介绍客户ID",
    crfReferralCustomerName: "转介绍客户名称",
    crfPurchaseOrderNo: "采购单号",
    crfPaymentStatus: "支付状态",
    crfOrderStatus: "订单状态",
    crfProductName: "产品名称",
    crfPurchaseQuantity: "采购数量",
    crfDeliveryQuantity: "发货数量",
    crfPurchaseUnitPrice: "采购单价",
    crfPurchaseTotalAmount: "采购总金额",
    crfRenewOrderPaymentAmount: "续费货款支付金额",
    crfDeliveryTime: "发货时间",
    crfSubscriptionFeeAmount: "订阅费金额",
    crfRewardCoefficient: "奖励系数",
    crfRewardGranted: "是否已发奖励",
    crfSubscriptionFeeRebate: "订阅费返佣",
    crfValueAddedServiceFee: "增值服务费",
    crfSettlementYearMonth: "结算年月",
    crfCumulativeChannelLevel: "累计渠道级别",
    crfChannelAgentId: "渠道代ID",
    crfChannelAgentName: "渠道代名称"
  },
  inAndOut: {
    auto_1_139fd654: "警告仍有数据错误",
    auto_1_b9dc19e5: "关联订单",
    auto_2_2fd6123c: "部分数据错误若确认导",
    auto_2_40525a88: "提货单号",
    auto_3_9818d9d9: "代理商名称",
    auto_4_dea576f9: "创建人",
    auto_5_74d9ba3c: "所属仓库",
    auto_6_d1e81c55: "收货人",
    auto_7_e043905b: "收货人电话",
    auto_8_73c2f4c1: "省市区",
    auto_9_93c298c4: "发货状态",
    auto_10_91f7dd37: "云仓出库单号",
    auto_11_cd5e206e: "收货地址",
    auto_12_7776b108: "备注",
    auto_13_8d8a189e: "关联订单",
    auto_14_b13e13c2: "提货单号",
    auto_15_304026c0: "代理商名称",
    auto_16_d949d795: "创建人",
    auto_17_9577c244: "所属仓库",
    auto_18_5459cfcc: "收货人",
    auto_19_f69fde8a: "收货人电话",
    auto_20_6f03a2c9: "省市区",
    auto_21_df0b5b51: "发货状态",
    auto_22_c08a1c9b: "云仓出库单号",
    auto_23_1fe87c25: "收货地址",
    auto_24_6d306963: "备注",
    auto_25_92958a8d: "调库单号",
    auto_26_1b1e691e: "代理商名称",
    auto_27_1345f8be: "创建人",
    auto_28_9f7eb351: "发货仓库",
    auto_29_114d2d8e: "发货状态",
    auto_30_10d00f1b: "京东调整单号",
    auto_31_3077cfda: "收货仓库",
    auto_32_6d5da67f: "备注",
    auto_33_be3c245c: "调拨单号",
    auto_34_6e471e75: "单据状态",
    auto_35_fe4361fd: "提交时间",
    auto_36_4c3cba93: "云仓库调拨单号",
    auto_37_c77e7811: "发货状态",
    auto_38_bbc449d3: "创建人",
    auto_39_a8a196d5: "关联调拨单号",
    auto_40_ed76ccca: "备注",
    auto_41_f052cebf: "下载导入模板",
    auto_42_1c0777fe: "导入详情",
    auto_43_07be94eb: "下载导入模板"
  },
  referral: {
    auto_1_17a24c7c: "是否确认要删除该图片",
    auto_1_35aee83a: "微信扫一扫预览",
    auto_2_05b0a2c5: "图片删除",
    auto_2_7cc4dc6c: "预览",
    auto_3_8d8a0d0a: "确定",
    auto_3_9d5473a6: "模板主题图片",
    auto_4_6bc3b01d: "模板背景图片",
    auto_4_cde7fb4a: "取消",
    auto_5_037ad60c: "是否确认要发布该图片",
    auto_6_00c325b5: "图片发布",
    auto_7_3a6109f8: "确定",
    auto_8_a478394a: "取消",
    auto_9_be2c267b: "是否确认要下架该图片",
    auto_10_6945e73a: "图片下架",
    auto_11_79b14662: "确定",
    auto_12_b6180373: "取消",
    auto_13_5eb2aadb: "预览图片",
    auto_14_7160357c: "删除图片",
    auto_15_df260266: "预览图片",
    auto_16_acb384af: "删除图片",
    auto_17_14df2a60: "请选择",
    auto_18_74d349b5: "请选择"
  },
  noviceTasks: {
    auto_1_334e5e27: "请使用松鼠Ai账号绑定的钉钉扫码报名",
    auto_1_38604ac9: "未解锁",
    auto_2_541d9670: "确定",
    auto_2_cc866735: "前往采购",
    auto_3_1f99f135: "请阅读至页面底部并至少阅读10秒钟",
    auto_3_50099175: "立即配置",
    auto_4_820c4504: "请使用微信扫描二维码添加总部专属微信",
    auto_4_861380f9: "我知道了",
    auto_5_76791bc2: "云课堂学习资格已领取",
    auto_5_8ae23169: "帮助中心",
    auto_6_6d258c8a: "报名",
    auto_6_c9482bb1: "提示",
    auto_7_3a6109f8: "确定",
    auto_7_4f1f7097: "添加松鼠AI总部企业微信"
  },
  pineconeBusiness: {
    auto_1_144af95b: "取消",
    auto_2_3f59f53b: "提交",
    auto_3_43d3c963: "开通体验账号",
    auto_4_8f9f1606: "经销商",
    auto_5_c037cf10: "备考省",
    auto_6_c8b7bdd1: "学员手机号",
    auto_7_d69a6971: "请输入学员手机号",
    auto_8_4240a3a7: "学员姓名",
    auto_9_56564323: "请输入学员姓名",
    auto_10_a0d4449d: "阶段年级",
    auto_11_593fdd20: "请选择阶段年级",
    auto_12_0d9ebca8: "体验日期",
    auto_13_92aec48d: "请选择体验日期"
  },
  systemManage: {
    auto_1_ea5a1f41: "分机号/坐席号",
    auto_2_6eaed7f7: "请输入分机号",
    auto_3_f5a4a6b9: "请输入坐席号",
    auto_4_889e956a: "外呼显示手机号",
    auto_5_74b44b16: "请输入外呼显示手机号"
  },
  loadingRedirect: '加载中…',
}
